import FootballState from "../../../../football/state/football-state";
import DriveService from "../../../../../services/drive-service";
import FootballStatsCategory from "../../../../football/stats/football-stats-category";
import StatsRule from "../../../../common/stats-rule";

export default class FlagPatCompleteStats extends StatsRule {
    static _resolvePatStatsFragmentAndPoints(play, fragment) {
        if (fragment.associatedState === FootballState.PatTry) {
            const statsFragment =
                play.getFirstFragment(FootballState.PatPass) ||
                play.getFirstFragment(FootballState.Run);

            const points = fragment.getScoringPoints();

            const player = statsFragment.passedBy || statsFragment.runBy;

            return { statsFragment, points, player };
        }

        return {};
    }

    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            ruleContext.PAT &&
            fragment.associatedState === FootballState.PatCompleted &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const patTryFragment = play.getFirstFragment(FootballState.PatTry);
        const { statsFragment, points, player } =
            FlagPatCompleteStats._resolvePatStatsFragmentAndPoints(
                play,
                patTryFragment,
                gameContext
            );

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: player.teamId,
            playerId: player.id,
            driveId: await DriveService.resolveDriveId(play, gameContext),
            fragmentId: statsFragment.id,
            category: FootballStatsCategory.PAT_COMPLETE,
            values: { points }
        });
    }
}
